import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=260f1b36&scoped=true&"
import script from "./pay.js?vue&type=script&lang=js&"
export * from "./pay.js?vue&type=script&lang=js&"
import style0 from "./pay.css?vue&type=style&index=0&id=260f1b36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f1b36",
  null
  
)

export default component.exports